<template>
    <div>
        <form-wrapper class="form__fields" :isSubmittable="false">
            <div class="auth-token-form">
                <text-field
                    :label="$t('pages.auth.verify_token.form.npi_number.label')"
                    :placeholder="$t('pages.auth.verify_token.form.npi_number.placeholder')"
                    :isRequired="true"
                    :hasAutofocus="true"
                    :formData="data"
                    :isDisabled="isLoading"
                    :error="npiErrorMessage"
                    valuePath="npiNumber"
                    @change="change($event)"
                ></text-field>

                <text-field
                    :label="$t('pages.auth.verify_token.form.token.label')"
                    :placeholder="$t('pages.auth.verify_token.form.token.placeholder')"
                    :isRequired="true"
                    :formData="data"
                    :isDisabled="isLoading"
                    :error="tokenErrorMessage"
                    valuePath="token"
                    @change="change($event)"
                ></text-field>

                <common-buttons class="verify-buttons">
                    <common-button
                        :label="$t('pages.auth.verify_token.form.verify')"
                        :isProcessing="isLoading"
                        type="primary"
                        size="small"
                        @click="verifyToken"
                    ></common-button>
                </common-buttons>
            </div>
        </form-wrapper>

        <verify-email-modal
            :isOpen="isEmailModalOpen"
            :npiNumber="data.npiNumber"
            :token="data.token"
            :closeOnClickAway="false"
            @close="isEmailModalOpen = false"
            @email-submitted="handleEmailSubmitted"
        ></verify-email-modal>

        <verify-code-modal
            :isOpen="isCodeModalOpen"
            :email="userEmail"
            :accessLogId="externalProviderReferralsAccessLogId"
            :closeOnClickAway="false"
            @close="isCodeModalOpen = false"
            @code-verified="handleCodeVerified"
        ></verify-code-modal>

        <referral-info-modal
            :isOpen="isReferralInfoModalOpen"
            :referral="referral"
            :referralPoolId="referral && referral.id ? String(referral.id) : null"
            :npiNumber="data.npiNumber"
            :token="data.token"
            :closeOnClickAway="false"
            @close="isReferralInfoModalOpen = false"
        ></referral-info-modal>
    </div>
</template>

<script>
    import FormMixin from 'mixins/FormMixin'
    import VerifyEmailModal from 'components/page-elements/auth/VerifyEmailModal'
    import VerifyCodeModal from 'components/page-elements/auth/VerifyCodeModal'
    import ReferralInfoModal from 'components/page-elements/auth/ReferralInfoModal'
    import ReferralsPoolAPI from 'api/ReferralsPoolAPI'

    export default {
        mixins: [FormMixin],

        components: {
            VerifyEmailModal,
            VerifyCodeModal,
            ReferralInfoModal,
        },

        data() {
            return {
                isLoading: false,
                npiErrorMessage: '',
                tokenErrorMessage: '',
                data: {
                    npiNumber: '',
                    token: '',
                },
                isEmailModalOpen: false,
                isCodeModalOpen: false,
                isReferralInfoModalOpen: false,
                userEmail: '',
                externalProviderReferralsAccessLogId: null,
                referral: null,
            }
        },

        methods: {
            async verifyToken() {
                this.npiErrorMessage = ''
                this.tokenErrorMessage = ''

                if (this.data.npiNumber.length !== 10) {
                    this.npiErrorMessage = this.$t('pages.auth.verify_token.errors.npi_must_be_10_digits')
                    return
                }

                if (!this.data.token) {
                    this.tokenErrorMessage = this.$t('pages.auth.verify_token.errors.token_required')
                    return
                }

                this.isLoading = true

                ReferralsPoolAPI.accessWithToken(this.data.npiNumber, this.data.token.trim())
                    .then((response) => {
                        if (response.emailRegistered) {
                            ReferralsPoolAPI.verifyWithToken(response.token, response.externalProviderReferralsAccessLogId)
                                .then((referral) => {
                                    this.isReferralInfoModalOpen = true
                                    this.referral = referral
                                })
                                .catch(() => {
                                    this.tokenErrorMessage = this.$t('pages.auth.verify_token.errors.token_invalid')
                                })
                                .finally(() => {
                                    this.isLoading = false
                                })
                        } else {
                            this.isEmailModalOpen = true
                        }
                    })
                    .catch((error) => {
                        this.error = error.response
                        this.isLoading = false

                        if (this.error.data[0].field === 'token' && this.error.data[0].code === 'entity.expired') {
                            this.tokenErrorMessage = this.$t('pages.auth.verify_token.errors.token_expired')
                        } else if (this.error.data[0].field === 'token' && this.error.data[0].code === 'entity.invalid') {
                            this.tokenErrorMessage = this.$t('pages.auth.verify_token.errors.token_invalid')
                        } else {
                            this.tokenErrorMessage = this.$t('pages.auth.verify_token.errors.token_invalid_common')
                        }
                    })
            },

            handleEmailSubmitted(payload) {
                this.userEmail = payload.email
                this.externalProviderReferralsAccessLogId = payload.externalProviderReferralsAccessLogId
                this.isEmailModalOpen = false
                this.isCodeModalOpen = true
            },

            handleCodeVerified(referral) {
                this.isCodeModalOpen = false
                this.isReferralInfoModalOpen = true
                this.referral = referral
            },
        },

        mounted() {
            if (this.$route.query.token) {
                this.data.token = this.$route.query.token
            }
        },
    }
</script>

<style scoped lang="scss">
    .auth-token-form {
        display: flex;
        flex-direction: column;
        gap: 18px;
    }

    .verify-buttons {
        margin-top: 5px;
    }
</style>
